import { theme as antdTheme } from "antd";

//paleta Inmersial: solo los colores de la marca (azules, celeste y cian); el asistente usa los mismos
export const colores = {
  fondo: "#03070F",
  panel: "#050B17",
  superficie: "#0A1222",
  superficieAlta: "#0F1A2E",
  borde: "#1B2A44",
  bordeSuave: "#13213A",
  texto: "#E8EEF8",
  textoSecundario: "#A9B6CC",
  textoTenue: "#8FA0BC",
  celeste: "#64ADF2",
  cian: "#1AB3E6",
  verde: "#22C38E",
  amarillo: "#F2C063",
  rojo: "#FF9B9B",
};

export const temaInmersial = {
  algorithm: antdTheme.darkAlgorithm,
  token: {
    colorPrimary: colores.celeste,
    colorInfo: colores.celeste,
    colorSuccess: colores.verde,
    colorWarning: colores.amarillo,
    colorLink: colores.celeste,
    colorBgBase: colores.fondo,
    colorBgLayout: colores.fondo,
    colorBgContainer: colores.superficie,
    colorBgElevated: colores.superficieAlta,
    colorBorder: colores.borde,
    colorBorderSecondary: colores.bordeSuave,
    colorText: colores.texto,
    colorTextSecondary: colores.textoSecundario,
    colorTextTertiary: colores.textoTenue,
    fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    borderRadius: 10,
    controlHeight: 38,
  },
  components: {
    Layout: {
      bodyBg: colores.fondo,
      headerBg: colores.panel,
      siderBg: colores.panel,
      headerPadding: "0 20px",
    },
    Menu: {
      darkItemBg: colores.panel,
      darkSubMenuItemBg: colores.fondo,
      darkItemSelectedBg: "#0F2757",
      darkItemSelectedColor: colores.texto,
      darkItemColor: colores.textoSecundario,
      darkItemHoverColor: colores.texto,
    },
    Button: { primaryColor: colores.fondo, primaryShadow: "none" },
    Modal: { contentBg: colores.superficie, headerBg: colores.superficie, footerBg: colores.superficie },
    Drawer: { colorBgElevated: colores.superficie },
    Table: { headerBg: colores.panel, rowHoverBg: colores.superficieAlta },
    Collapse: { headerBg: colores.superficie, contentBg: colores.panel },
    Card: { colorBgContainer: colores.superficie },
  },
};
